<script>
import ProgressBar from '@components/custom-progress'

export default {
  components: { ProgressBar },
  props: {
    report: { type: String, default: '' },
    progressValue: { type: Number, default: 0 },
    progressMaxValue: { type: Number, default: 100 },
  },
}
</script>

<template>
  <v-list>
    <v-list-tile class="pt-1 pb-2">
      <v-list-tile-action>
        <v-btn
          aria-label="landing page return"
          icon
          class="mt-0 mb-0 app-icon-content"
          to="/dataViz">
          <v-icon
            style="color: #243f92"
            large>apps</v-icon>
        </v-btn>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title class="report-name">{{ report }}</v-list-tile-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <ProgressBar
          :value="progressValue"
          :max="progressMaxValue"
          class="progress-width"/>
      </v-list-tile-action>
    </v-list-tile>
  </v-list>
</template>

<style scoped>
.app-icon-content >>> .btn__content {
  color: rgba(255, 255, 255, 1);
}
.report-name {
  font-size: 24px;
}
.progress-width {
  width: 200px;
}
.list__tile__title {
  height: 30px;
}
</style>
